import {
  DeleteWorkAreaMapSpaceLocationDocument,
  DeleteWorkAreaMapSpaceLocationMutation,
  DeleteWorkAreaMapSpaceLocationMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteWorkAreaMapSpaceLocation = () => {
  const [executeMutation] = useMutation(DeleteWorkAreaMapSpaceLocationDocument, {
    extractorFn: (data: DeleteWorkAreaMapSpaceLocationMutation) =>
      data.spaceControlMutations.deleteSpacecontrolWorkAreaMapSpaceLocation,
  })

  const deleteWorkAreaMapSpaceLocation = async (
    variables: DeleteWorkAreaMapSpaceLocationMutationVariables
  ) => {
    return executeMutation({
      variables,
    })
  }

  return {
    deleteWorkAreaMapSpaceLocation,
  }
}
